/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as ClerkRouteRouteImport } from './routes/clerk/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRequestsIndexRouteImport } from './routes/_authenticated/requests/index'
import { Route as AuthenticatedMapIndexRouteImport } from './routes/_authenticated/map/index'
import { Route as AuthenticatedLeadsIndexRouteImport } from './routes/_authenticated/leads/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedFlaggedIssuesIndexRouteImport } from './routes/_authenticated/flagged-issues/index'
import { Route as AuthenticatedEmailsIndexRouteImport } from './routes/_authenticated/emails/index'
import { Route as AuthenticatedDummyRequestsIndexRouteImport } from './routes/_authenticated/dummy-requests/index'
import { Route as AuthenticatedChefsIndexRouteImport } from './routes/_authenticated/chefs/index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedAffiliatesIndexRouteImport } from './routes/_authenticated/affiliates/index'
import { Route as ClerkAuthenticatedUserManagementRouteImport } from './routes/clerk/_authenticated/user-management'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsMcpAccessRouteImport } from './routes/_authenticated/settings/mcp-access'
import { Route as AuthenticatedSettingsKnowledgeBaseRouteImport } from './routes/_authenticated/settings/knowledge-base'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAiResponsesRouteImport } from './routes/_authenticated/settings/ai-responses'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedEmailsSettingsRouteImport } from './routes/_authenticated/emails/settings'
import { Route as AuthenticatedEmailsInboxRouteImport } from './routes/_authenticated/emails/inbox'
import { Route as AuthenticatedB2b2cRequestsIndexRouteImport } from './routes/_authenticated/b2b2c/requests/index'
import { Route as AuthenticatedB2b2cIntegrationsIndexRouteImport } from './routes/_authenticated/b2b2c/integrations/index'
import { Route as AuthenticatedB2b2cAutomationsIndexRouteImport } from './routes/_authenticated/b2b2c/automations/index'

const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkRouteRoute = ClerkRouteRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedRequestsIndexRoute =
  AuthenticatedRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMapIndexRoute = AuthenticatedMapIndexRouteImport.update({
  id: '/map/',
  path: '/map/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLeadsIndexRoute = AuthenticatedLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFlaggedIssuesIndexRoute =
  AuthenticatedFlaggedIssuesIndexRouteImport.update({
    id: '/flagged-issues/',
    path: '/flagged-issues/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmailsIndexRoute =
  AuthenticatedEmailsIndexRouteImport.update({
    id: '/emails/',
    path: '/emails/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDummyRequestsIndexRoute =
  AuthenticatedDummyRequestsIndexRouteImport.update({
    id: '/dummy-requests/',
    path: '/dummy-requests/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChefsIndexRoute = AuthenticatedChefsIndexRouteImport.update({
  id: '/chefs/',
  path: '/chefs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAffiliatesIndexRoute =
  AuthenticatedAffiliatesIndexRouteImport.update({
    id: '/affiliates/',
    path: '/affiliates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const ClerkAuthenticatedUserManagementRoute =
  ClerkAuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => ClerkAuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsMcpAccessRoute =
  AuthenticatedSettingsMcpAccessRouteImport.update({
    id: '/mcp-access',
    path: '/mcp-access',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsKnowledgeBaseRoute =
  AuthenticatedSettingsKnowledgeBaseRouteImport.update({
    id: '/knowledge-base',
    path: '/knowledge-base',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAiResponsesRoute =
  AuthenticatedSettingsAiResponsesRouteImport.update({
    id: '/ai-responses',
    path: '/ai-responses',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmailsSettingsRoute =
  AuthenticatedEmailsSettingsRouteImport.update({
    id: '/emails/settings',
    path: '/emails/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmailsInboxRoute =
  AuthenticatedEmailsInboxRouteImport.update({
    id: '/emails/inbox',
    path: '/emails/inbox',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedB2b2cRequestsIndexRoute =
  AuthenticatedB2b2cRequestsIndexRouteImport.update({
    id: '/b2b2c/requests/',
    path: '/b2b2c/requests/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedB2b2cIntegrationsIndexRoute =
  AuthenticatedB2b2cIntegrationsIndexRouteImport.update({
    id: '/b2b2c/integrations/',
    path: '/b2b2c/integrations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedB2b2cAutomationsIndexRoute =
  AuthenticatedB2b2cAutomationsIndexRouteImport.update({
    id: '/b2b2c/automations/',
    path: '/b2b2c/automations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/emails/inbox': typeof AuthenticatedEmailsInboxRoute
  '/emails/settings': typeof AuthenticatedEmailsSettingsRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/ai-responses': typeof AuthenticatedSettingsAiResponsesRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/knowledge-base': typeof AuthenticatedSettingsKnowledgeBaseRoute
  '/settings/mcp-access': typeof AuthenticatedSettingsMcpAccessRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/affiliates/': typeof AuthenticatedAffiliatesIndexRoute
  '/apps/': typeof AuthenticatedAppsIndexRoute
  '/chefs/': typeof AuthenticatedChefsIndexRoute
  '/dummy-requests/': typeof AuthenticatedDummyRequestsIndexRoute
  '/emails/': typeof AuthenticatedEmailsIndexRoute
  '/flagged-issues/': typeof AuthenticatedFlaggedIssuesIndexRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/leads/': typeof AuthenticatedLeadsIndexRoute
  '/map/': typeof AuthenticatedMapIndexRoute
  '/requests/': typeof AuthenticatedRequestsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/b2b2c/automations/': typeof AuthenticatedB2b2cAutomationsIndexRoute
  '/b2b2c/integrations/': typeof AuthenticatedB2b2cIntegrationsIndexRoute
  '/b2b2c/requests/': typeof AuthenticatedB2b2cRequestsIndexRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/emails/inbox': typeof AuthenticatedEmailsInboxRoute
  '/emails/settings': typeof AuthenticatedEmailsSettingsRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/ai-responses': typeof AuthenticatedSettingsAiResponsesRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/knowledge-base': typeof AuthenticatedSettingsKnowledgeBaseRoute
  '/settings/mcp-access': typeof AuthenticatedSettingsMcpAccessRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/affiliates': typeof AuthenticatedAffiliatesIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/chefs': typeof AuthenticatedChefsIndexRoute
  '/dummy-requests': typeof AuthenticatedDummyRequestsIndexRoute
  '/emails': typeof AuthenticatedEmailsIndexRoute
  '/flagged-issues': typeof AuthenticatedFlaggedIssuesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/leads': typeof AuthenticatedLeadsIndexRoute
  '/map': typeof AuthenticatedMapIndexRoute
  '/requests': typeof AuthenticatedRequestsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/b2b2c/automations': typeof AuthenticatedB2b2cAutomationsIndexRoute
  '/b2b2c/integrations': typeof AuthenticatedB2b2cIntegrationsIndexRoute
  '/b2b2c/requests': typeof AuthenticatedB2b2cRequestsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/clerk': typeof ClerkRouteRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/emails/inbox': typeof AuthenticatedEmailsInboxRoute
  '/_authenticated/emails/settings': typeof AuthenticatedEmailsSettingsRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/ai-responses': typeof AuthenticatedSettingsAiResponsesRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/knowledge-base': typeof AuthenticatedSettingsKnowledgeBaseRoute
  '/_authenticated/settings/mcp-access': typeof AuthenticatedSettingsMcpAccessRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/_authenticated/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/_authenticated/affiliates/': typeof AuthenticatedAffiliatesIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/chefs/': typeof AuthenticatedChefsIndexRoute
  '/_authenticated/dummy-requests/': typeof AuthenticatedDummyRequestsIndexRoute
  '/_authenticated/emails/': typeof AuthenticatedEmailsIndexRoute
  '/_authenticated/flagged-issues/': typeof AuthenticatedFlaggedIssuesIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/leads/': typeof AuthenticatedLeadsIndexRoute
  '/_authenticated/map/': typeof AuthenticatedMapIndexRoute
  '/_authenticated/requests/': typeof AuthenticatedRequestsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/b2b2c/automations/': typeof AuthenticatedB2b2cAutomationsIndexRoute
  '/_authenticated/b2b2c/integrations/': typeof AuthenticatedB2b2cIntegrationsIndexRoute
  '/_authenticated/b2b2c/requests/': typeof AuthenticatedB2b2cRequestsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clerk'
    | '/sso-callback'
    | '/settings'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/emails/inbox'
    | '/emails/settings'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/ai-responses'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/knowledge-base'
    | '/settings/mcp-access'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/affiliates/'
    | '/apps/'
    | '/chefs/'
    | '/dummy-requests/'
    | '/emails/'
    | '/flagged-issues/'
    | '/help-center/'
    | '/leads/'
    | '/map/'
    | '/requests/'
    | '/settings/'
    | '/users/'
    | '/b2b2c/automations/'
    | '/b2b2c/integrations/'
    | '/b2b2c/requests/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/sso-callback'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/emails/inbox'
    | '/emails/settings'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/ai-responses'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/knowledge-base'
    | '/settings/mcp-access'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/affiliates'
    | '/apps'
    | '/chefs'
    | '/dummy-requests'
    | '/emails'
    | '/flagged-issues'
    | '/help-center'
    | '/leads'
    | '/map'
    | '/requests'
    | '/settings'
    | '/users'
    | '/b2b2c/automations'
    | '/b2b2c/integrations'
    | '/b2b2c/requests'
  id:
    | '__root__'
    | '/_authenticated'
    | '/clerk'
    | '/sso-callback'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/emails/inbox'
    | '/_authenticated/emails/settings'
    | '/_authenticated/errors/$error'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/ai-responses'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/knowledge-base'
    | '/_authenticated/settings/mcp-access'
    | '/_authenticated/settings/notifications'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/clerk/_authenticated/user-management'
    | '/_authenticated/affiliates/'
    | '/_authenticated/apps/'
    | '/_authenticated/chefs/'
    | '/_authenticated/dummy-requests/'
    | '/_authenticated/emails/'
    | '/_authenticated/flagged-issues/'
    | '/_authenticated/help-center/'
    | '/_authenticated/leads/'
    | '/_authenticated/map/'
    | '/_authenticated/requests/'
    | '/_authenticated/settings/'
    | '/_authenticated/users/'
    | '/_authenticated/b2b2c/automations/'
    | '/_authenticated/b2b2c/integrations/'
    | '/_authenticated/b2b2c/requests/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkRouteRoute: typeof ClerkRouteRouteWithChildren
  SsoCallbackRoute: typeof SsoCallbackRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/requests/': {
      id: '/_authenticated/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof AuthenticatedRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/map/': {
      id: '/_authenticated/map/'
      path: '/map'
      fullPath: '/map/'
      preLoaderRoute: typeof AuthenticatedMapIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leads/': {
      id: '/_authenticated/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AuthenticatedLeadsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/flagged-issues/': {
      id: '/_authenticated/flagged-issues/'
      path: '/flagged-issues'
      fullPath: '/flagged-issues/'
      preLoaderRoute: typeof AuthenticatedFlaggedIssuesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emails/': {
      id: '/_authenticated/emails/'
      path: '/emails'
      fullPath: '/emails/'
      preLoaderRoute: typeof AuthenticatedEmailsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dummy-requests/': {
      id: '/_authenticated/dummy-requests/'
      path: '/dummy-requests'
      fullPath: '/dummy-requests/'
      preLoaderRoute: typeof AuthenticatedDummyRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chefs/': {
      id: '/_authenticated/chefs/'
      path: '/chefs'
      fullPath: '/chefs/'
      preLoaderRoute: typeof AuthenticatedChefsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/affiliates/': {
      id: '/_authenticated/affiliates/'
      path: '/affiliates'
      fullPath: '/affiliates/'
      preLoaderRoute: typeof AuthenticatedAffiliatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/clerk/_authenticated/user-management': {
      id: '/clerk/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/clerk/user-management'
      preLoaderRoute: typeof ClerkAuthenticatedUserManagementRouteImport
      parentRoute: typeof ClerkAuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/mcp-access': {
      id: '/_authenticated/settings/mcp-access'
      path: '/mcp-access'
      fullPath: '/settings/mcp-access'
      preLoaderRoute: typeof AuthenticatedSettingsMcpAccessRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/knowledge-base': {
      id: '/_authenticated/settings/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/settings/knowledge-base'
      preLoaderRoute: typeof AuthenticatedSettingsKnowledgeBaseRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/ai-responses': {
      id: '/_authenticated/settings/ai-responses'
      path: '/ai-responses'
      fullPath: '/settings/ai-responses'
      preLoaderRoute: typeof AuthenticatedSettingsAiResponsesRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emails/settings': {
      id: '/_authenticated/emails/settings'
      path: '/emails/settings'
      fullPath: '/emails/settings'
      preLoaderRoute: typeof AuthenticatedEmailsSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/emails/inbox': {
      id: '/_authenticated/emails/inbox'
      path: '/emails/inbox'
      fullPath: '/emails/inbox'
      preLoaderRoute: typeof AuthenticatedEmailsInboxRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/b2b2c/requests/': {
      id: '/_authenticated/b2b2c/requests/'
      path: '/b2b2c/requests'
      fullPath: '/b2b2c/requests/'
      preLoaderRoute: typeof AuthenticatedB2b2cRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/b2b2c/integrations/': {
      id: '/_authenticated/b2b2c/integrations/'
      path: '/b2b2c/integrations'
      fullPath: '/b2b2c/integrations/'
      preLoaderRoute: typeof AuthenticatedB2b2cIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/b2b2c/automations/': {
      id: '/_authenticated/b2b2c/automations/'
      path: '/b2b2c/automations'
      fullPath: '/b2b2c/automations/'
      preLoaderRoute: typeof AuthenticatedB2b2cAutomationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAiResponsesRoute: typeof AuthenticatedSettingsAiResponsesRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsKnowledgeBaseRoute: typeof AuthenticatedSettingsKnowledgeBaseRoute
  AuthenticatedSettingsMcpAccessRoute: typeof AuthenticatedSettingsMcpAccessRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAiResponsesRoute:
      AuthenticatedSettingsAiResponsesRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsKnowledgeBaseRoute:
      AuthenticatedSettingsKnowledgeBaseRoute,
    AuthenticatedSettingsMcpAccessRoute: AuthenticatedSettingsMcpAccessRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedEmailsInboxRoute: typeof AuthenticatedEmailsInboxRoute
  AuthenticatedEmailsSettingsRoute: typeof AuthenticatedEmailsSettingsRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedAffiliatesIndexRoute: typeof AuthenticatedAffiliatesIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedChefsIndexRoute: typeof AuthenticatedChefsIndexRoute
  AuthenticatedDummyRequestsIndexRoute: typeof AuthenticatedDummyRequestsIndexRoute
  AuthenticatedEmailsIndexRoute: typeof AuthenticatedEmailsIndexRoute
  AuthenticatedFlaggedIssuesIndexRoute: typeof AuthenticatedFlaggedIssuesIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedLeadsIndexRoute: typeof AuthenticatedLeadsIndexRoute
  AuthenticatedMapIndexRoute: typeof AuthenticatedMapIndexRoute
  AuthenticatedRequestsIndexRoute: typeof AuthenticatedRequestsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedB2b2cAutomationsIndexRoute: typeof AuthenticatedB2b2cAutomationsIndexRoute
  AuthenticatedB2b2cIntegrationsIndexRoute: typeof AuthenticatedB2b2cIntegrationsIndexRoute
  AuthenticatedB2b2cRequestsIndexRoute: typeof AuthenticatedB2b2cRequestsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedEmailsInboxRoute: AuthenticatedEmailsInboxRoute,
  AuthenticatedEmailsSettingsRoute: AuthenticatedEmailsSettingsRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedAffiliatesIndexRoute: AuthenticatedAffiliatesIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedChefsIndexRoute: AuthenticatedChefsIndexRoute,
  AuthenticatedDummyRequestsIndexRoute: AuthenticatedDummyRequestsIndexRoute,
  AuthenticatedEmailsIndexRoute: AuthenticatedEmailsIndexRoute,
  AuthenticatedFlaggedIssuesIndexRoute: AuthenticatedFlaggedIssuesIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedLeadsIndexRoute: AuthenticatedLeadsIndexRoute,
  AuthenticatedMapIndexRoute: AuthenticatedMapIndexRoute,
  AuthenticatedRequestsIndexRoute: AuthenticatedRequestsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedB2b2cAutomationsIndexRoute:
    AuthenticatedB2b2cAutomationsIndexRoute,
  AuthenticatedB2b2cIntegrationsIndexRoute:
    AuthenticatedB2b2cIntegrationsIndexRoute,
  AuthenticatedB2b2cRequestsIndexRoute: AuthenticatedB2b2cRequestsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkAuthenticatedRouteRouteChildren {
  ClerkAuthenticatedUserManagementRoute: typeof ClerkAuthenticatedUserManagementRoute
}

const ClerkAuthenticatedRouteRouteChildren: ClerkAuthenticatedRouteRouteChildren =
  {
    ClerkAuthenticatedUserManagementRoute:
      ClerkAuthenticatedUserManagementRoute,
  }

const ClerkAuthenticatedRouteRouteWithChildren =
  ClerkAuthenticatedRouteRoute._addFileChildren(
    ClerkAuthenticatedRouteRouteChildren,
  )

interface ClerkRouteRouteChildren {
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRouteWithChildren
}

const ClerkRouteRouteChildren: ClerkRouteRouteChildren = {
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRouteWithChildren,
}

const ClerkRouteRouteWithChildren = ClerkRouteRoute._addFileChildren(
  ClerkRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkRouteRoute: ClerkRouteRouteWithChildren,
  SsoCallbackRoute: SsoCallbackRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
